import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getWebsiteAuditProcess(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Úvodní meeting",
			desc: "Začneme úvodní schůzkou, kde se vás zeptáme, jaký web provozujete, co vás trápí nebo které problémy by měl audit stránek vyřešit. Podrobně zanalyzujeme vaši aktuální situaci.",
		},
		{ title: "Audit", desc: "Provedeme audit webu, jehož výsledkem budou konkrétní návrhy a doporučení na zlepšení." },
		{
			title: "Aplikace úprav",
			desc: "Pokud budete chtít, po domluvě provedeme také optimalizaci stránek na základě auditu.",
		},
		{
			title: "Navazující spolupráce",
			desc: "Nenecháme vás v tom plavat. Rádi vám budeme k ruce dlouhodobě – při řešení starostí s webem i dalšími IT otázkami.",
		},
	];
}
